import { RegularBenefitVariant } from '../../../../../../../typings'

export const EMPTY_NOMINAL_PRICE = {
  type: RegularBenefitVariant.Nominal as const,
  value: undefined,
}
